import {Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import UnitCard from './UnitCard.component';

const SwiperContainer = ({ units, forceUpdate }) => {
    const mapUnits = ()  => (
        <Swiper
        spaceBetween={30}
        slidesPerView={"auto"}
        navigation
        modules={[Navigation]}
        className="unitsSwiper"
        centeredSlides
        breakpoints={{
            768: {
                centeredSlides: false
              },
        }}
    >
     {units.map((unit, i) => (
        <SwiperSlide key={i}>
            <UnitCard unit={unit} forceUpdate={forceUpdate} />
        </SwiperSlide>
    ))} 
    </Swiper>
);
    

    const noUnits = () => (<p className="units__noResults">Sorry, there are no results that match your criteria.</p>);

    return (units.length === 0 ? noUnits() : mapUnits())
       
}

export default SwiperContainer;